import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { EleViewBackFaceService } from '../../../services/eleview/eleview-backface';
import { Category } from '../../../services/eleview/types/category';
import { Label } from '../../../services/eleview/types/label';

export interface IMovePosition {
	category: Category;
	label: Label;
	previousIndex: number;
	currentIndex: number;
}

@Component({
	selector: 'common-category-for-select',
	templateUrl: './category-for-select.component.html',
	styleUrls: ['./category-for-select.component.scss']
})
export class CategoryForSelectComponent implements OnInit {
	@Input() category: Category;
	@Input() selectedLabels: Label[];
	labelDisplay = false;
	@HostBinding('class.category-for-select') hostClass = true;
	constructor(private svr: EleViewBackFaceService) {}

	ngOnInit() {}
	click(label: Label) {
		const idx = this.selectedLabels.findIndex(v => v.equal(label));

		if (idx > -1) {
			this.selectedLabels.splice(idx);
		} else {
			this.selectedLabels.push(label);
		}
	}
	drop(event: CdkDragDrop<Label[]>) {
		this.svr
			.setLabelPosition({
				CategoryID: this.category.ID,
				ID: this.category.Labels[event.previousIndex].ID,
				Position: event.currentIndex
			})
			.subscribe(v => {
				this.category.setLabelsPosition(v.map(vv => vv.ID));
			});
	}
	isSelected(data: Label) {
		return this.selectedLabels.find(v => v.equal(data)) !== undefined;
	}
}
